import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { useHeroHeaderChipVariant } from "@/components/hero-header/use-hero-header-chip-variant";
import { CollectionMetadataChipFragment } from "./CollectionMetadataChip.fragment";
import { CollectionCategoryChip } from "./chips/CollectionCategoryChip";
import { CollectionChainChip } from "./chips/CollectionChainChip";
import { CollectionCreatedAtChip } from "./chips/CollectionCreatedAtChip";
import { CollectionDropStatusChip } from "./chips/CollectionDropStatusChip";
import { CollectionFloorPriceChip } from "./chips/CollectionFloorPriceChip";
import { CollectionItemCountChip } from "./chips/CollectionItemCountChip";
import { CollectionOwnerChip } from "./chips/CollectionOwnerChip";
export function CollectionMetadataChip(t0) {
  const $ = _c(42);
  let chip;
  let collectionKey;
  let rest;
  let variant;
  if ($[0] !== t0) {
    ({
      chip,
      collection: collectionKey,
      variant,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = chip;
    $[2] = collectionKey;
    $[3] = rest;
    $[4] = variant;
  } else {
    chip = $[1];
    collectionKey = $[2];
    rest = $[3];
    variant = $[4];
  }
  let t1;
  if ($[5] !== collectionKey) {
    t1 = readFragment(CollectionMetadataChipFragment, collectionKey);
    $[5] = collectionKey;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const collection = t1;
  const chipVariant = useHeroHeaderChipVariant();
  switch (chip) {
    case "owner":
      {
        let t2;
        if ($[7] !== chipVariant || $[8] !== collection || $[9] !== rest || $[10] !== variant) {
          t2 = <CollectionOwnerChip chipVariant={chipVariant} collection={collection} variant={variant} {...rest} />;
          $[7] = chipVariant;
          $[8] = collection;
          $[9] = rest;
          $[10] = variant;
          $[11] = t2;
        } else {
          t2 = $[11];
        }
        return t2;
      }
    case "item_count":
      {
        let t2;
        if ($[12] !== chipVariant || $[13] !== collection || $[14] !== rest || $[15] !== variant) {
          t2 = <CollectionItemCountChip chipVariant={chipVariant} collection={collection} variant={variant} {...rest} />;
          $[12] = chipVariant;
          $[13] = collection;
          $[14] = rest;
          $[15] = variant;
          $[16] = t2;
        } else {
          t2 = $[16];
        }
        return t2;
      }
    case "created_at":
      {
        let t2;
        if ($[17] !== chipVariant || $[18] !== collection || $[19] !== rest || $[20] !== variant) {
          t2 = <CollectionCreatedAtChip collection={collection} {...rest} chipVariant={chipVariant} variant={variant} />;
          $[17] = chipVariant;
          $[18] = collection;
          $[19] = rest;
          $[20] = variant;
          $[21] = t2;
        } else {
          t2 = $[21];
        }
        return t2;
      }
    case "chain":
      {
        let t2;
        if ($[22] !== chipVariant || $[23] !== collection || $[24] !== rest) {
          t2 = <CollectionChainChip collection={collection} variant={chipVariant} {...rest} />;
          $[22] = chipVariant;
          $[23] = collection;
          $[24] = rest;
          $[25] = t2;
        } else {
          t2 = $[25];
        }
        return t2;
      }
    case "chain_badge":
      {
        let t2;
        if ($[26] !== chipVariant || $[27] !== collection || $[28] !== rest) {
          t2 = <CollectionChainChip badge={true} collection={collection} variant={chipVariant} {...rest} />;
          $[26] = chipVariant;
          $[27] = collection;
          $[28] = rest;
          $[29] = t2;
        } else {
          t2 = $[29];
        }
        return t2;
      }
    case "category":
      {
        let t2;
        if ($[30] !== chipVariant || $[31] !== collection || $[32] !== rest) {
          t2 = <CollectionCategoryChip collection={collection} variant={chipVariant} {...rest} />;
          $[30] = chipVariant;
          $[31] = collection;
          $[32] = rest;
          $[33] = t2;
        } else {
          t2 = $[33];
        }
        return t2;
      }
    case "floor_price":
      {
        let t2;
        if ($[34] !== chipVariant || $[35] !== collection || $[36] !== rest) {
          t2 = <CollectionFloorPriceChip collection={collection} variant={chipVariant} {...rest} />;
          $[34] = chipVariant;
          $[35] = collection;
          $[36] = rest;
          $[37] = t2;
        } else {
          t2 = $[37];
        }
        return t2;
      }
    case "drop_status":
      {
        let t2;
        if ($[38] !== chipVariant || $[39] !== collection || $[40] !== rest) {
          t2 = <CollectionDropStatusChip collection={collection} variant={chipVariant} {...rest} />;
          $[38] = chipVariant;
          $[39] = collection;
          $[40] = rest;
          $[41] = t2;
        } else {
          t2 = $[41];
        }
        return t2;
      }
  }
}